// extracted by mini-css-extract-plugin
module.exports = {"componentsOpenNativeList":"styles_componentsOpenNativeList__2zpYQ","notSupportInfo":"styles_notSupportInfo__1Q1SY","opText":"styles_opText__4Dxvo"};